/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Wechat_EnabledInputs */

const en_admin_settings_fields_wechat_enabled = /** @type {(inputs: Admin_Settings_Fields_Wechat_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable WeChat Pay`)
};

const zh_admin_settings_fields_wechat_enabled = /** @type {(inputs: Admin_Settings_Fields_Wechat_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用微信支付`)
};

/**
* | output |
* | --- |
* | "Enable WeChat Pay" |
*
* @param {Admin_Settings_Fields_Wechat_EnabledInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_wechat_enabled = /** @type {((inputs?: Admin_Settings_Fields_Wechat_EnabledInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Wechat_EnabledInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_wechat_enabled(inputs)
	return zh_admin_settings_fields_wechat_enabled(inputs)
});
export { admin_settings_fields_wechat_enabled as "admin.settings.fields.wechat_enabled" }